<template>
  <div v-if="showFlag">
    <div class="dialog_mask"
         @click="hide"></div>
    <div class="dialog_container">
      <div class="dialog-head">
        <img class="icon-close"
             @click="hide"
             src="../assets/pop_icon_cancle.svg" />
        <div class="head-font">
          <div class="head-bank fix-1px"></div>
          <div class="head-bank"></div>
        </div>
        <div class="ot-color etc-font">保存电子照</div>
        <div class="head-font">
          <div class="head-bank fix-1px"></div>
          <div class="head-bank"></div>
        </div>
      </div>
      <div class="dialog-icon">
        <div class="icon-item">
          <div class="img-div">
            <img @click="choiceTap(1)"
                 class="icon-img"
                 src="../assets/download_icon_phone@3x.png" />
          </div>
          <div :class="choiceNum==1?'icon-font':'icon-nocolor'">保存到手机</div>
        </div>
        <div class="icon-item">
          <div>
            <img @click="choiceTap(2)"
                 class="icon-img"
                 src="../assets/download_icon_key@3x.png" />
          </div>
          <div :class="choiceNum==2?'icon-font':'icon-nocolor'">提取码</div>
        </div>
        <div class="icon-item">
          <div class="img-div">
            <img @click="choiceTap(3)"
                 class="icon-img"
                 src="../assets/download_icon_email@3x.png" />
          </div>
          <div :class="choiceNum==3?'icon-font':'icon-nocolor'">发送到邮箱</div>
        </div>
      </div>
      <div class="triangle-group">
        <img class="triangle1"
             v-if="choiceNum==1"
             src="../assets/sqare.png" />
        <img class="triangle2"
             v-if="choiceNum==2"
             src="../assets/sqare.png" />
        <img class="triangle3"
             v-if="choiceNum==3"
             src="../assets/sqare.png" />
      </div>
      <div class="dialog-tip"
           v-show="choiceNum==1">直接保存至手机会对图片进行压缩哦（影响图片大小）</div>
      <div class="dialog-tip"
           v-show="choiceNum==2">请在“电脑浏览器”中打开网址提取证件照</div>
      <div class="dialog-tip"
           v-show="choiceNum==3">请在以下输入框中输入您的邮箱,每单最多可以发送3次</div>
      <div class="dialog-form">
        <div class="form-item"
             v-show="choiceNum==2">
          <div class="item-label">下载地址</div>
          <div class="label-text">{{extractCode.url}}</div>
        </div>
        <div class="form-item"
             v-show="choiceNum==2">
          <div class="item-label">提取码</div>
          <div class="label-text">{{extractCode.extract_code}}</div>
        </div>
        <div class="form-item"
             v-show="choiceNum==3">
          <div class="item-label">电子邮箱</div>
          <div class="label-text"><input class="input-class"
                   name="email"
                   v-model="email"
                   placeholder="请输入您的邮箱" /></div>
        </div>
      </div>
      <div class="dialog-button">
        <div class="btn nor-bg-color"
             v-show="choiceNum==1"
             @click="save">保存到手机相册</div>
        <div class="btn nor-bg-color tag"
             v-show="choiceNum==2"
             @click="saveCode">复制地址及提取码</div>
        <div class="btn nor-bg-color"
             v-show="choiceNum==3"
             @click="saveToEmail">发送至指定邮箱</div>
      </div>
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard';
import {Toast,MessageBox} from 'mint-ui';
import {mapActions,mapState} from 'vuex';
import {emailReg} from '@/utils/utils';
import { setTimeout } from 'timers';
export default {
  props: ['showFlag', 'choiceNum','extractCode','orderId'],
  data () {
    return {
      email: '',
      loadingFlag: false,
      singleClick:true //防连点
    }
  },
  computed:{
    ...mapState(['platformInfo'])
  },
  methods: {
    ...mapActions(['sendeleEmail']),
    save () {
      if(!this.singleClick){
        return;
      }
      this.hide();
      setTimeout(()=>{
        this.singleClick = true;
      },1000)
      this.showFlag=false;
      this.sdk.savePhone(this.orderId,this.platformInfo.platform)
    },
    saveCode () {
      let {extract_code,url} = this.extractCode;
      let clipboard = new Clipboard('.tag', {
        text: function () {
          return `下载地址：${url}\n提取码：${extract_code}`;
        }
      })
      this.hide();
      clipboard.on('success', e => {
       Toast({
          message: '复制成功',
        });
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        Toast({
          message: '复制失败',
        });
        clipboard.destroy()
      })
    },
    saveToEmail () {
      this.email = this.email.trim()
      let res = emailReg(this.email);
      if(!res.success) {
        Toast({
          message:res.msg
        });
        return;
      }
      MessageBox({
        title: '温馨提示',
        message: '确认发送到该邮箱吗？<br/>'+this.email,
        showCancelButton: true,
        confirmButtonText:'确认',
        cancelButtonText:'重新输入'
      }).then(mesres=>{
        if(mesres==='confirm'){
          this.sendeleEmail({
            email:this.email,
            order_id:this.orderId
          }).then(res=>{
            this.hide();
            if(res.data.code!==200){
              return;
            }
            Toast({
              message:res.data.message
            });
          })
        }
      })
    },
    choiceTap (idx) {
      this.$emit('choiceTap', idx)
    },
    hide () {
      this.$emit('hide')
    }
  },
}
</script>

<style scoped>
.dialog-form {
  width: 100%;
  flex-direction: column;
}
.form-item {
  height: 0.55rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.14rem;
  color: #666666;
}
.item-label {
  display: flex;
  justify-content: flex-start;
  margin-left: 0.25rem;
}
.label-text {
  display: flex;
  justify-content: flex-end;
  margin-right: 0.25rem;
}
.icon-close {
  position: absolute;
  top: -0.1rem;
  right: 0.1rem;
  height: 0.16rem;
  width: 0.16rem;
}
.triangle-group {
  margin-top: 0.2rem;
}
.dialog-button {
  margin-top: 0.2rem;
  height: 0.6rem;
  width: 100%;
  justify-content: center;
  align-items: center;
  box-shadow: #d3d3d3 0.05rem 0.05rem 0.15rem 0.025rem;
}
.input-class{
  width: 1.87rem;
  border: none;
  outline: none;
}
.btn {
  border-radius: 0.2rem;
  height: 0.45rem;
  width: 3.55rem;
  line-height: 0.45rem;
  justify-content: center;
  color: #ffffff;
  font-size: 0.16rem;
  background-color: #5254ff;
}
.dialog-tip {
  background-color: #fff9f0;
  height: 0.4rem;
  width: 100%;
  justify-content: center;
  align-items: center;
  font-size: 0.13rem;
  color: #f5a623;
}
.triangle1 {
  width: 0.16rem;
  height: 0.1rem;
  margin-left: 0.57rem;
}
.triangle2 {
  width: 0.16rem;
  height: 0.1rem;
  margin-left: 1.8rem;
}
.triangle3 {
  width: 0.16rem;
  height: 0.1rem;
  margin-left: 3.05rem;
}
.icon-font {
  color: #f5a623;
  font-size: 0.12rem;
  margin: 0 auto;
}
.icon-nocolor {
  color: #999999;
  font-size: 0.12rem;
  margin: 0 auto;
}
.img-div {
  width: 100%;
  justify-content: center;
}
.dialog-icon {
  justify-content: space-around;
}
.icon-item {
  flex-direction: column;
}
.icon-img {
  height: 0.5rem;
  width: 0.5rem;
}
.head-font {
  width: 0.2rem;
  flex-direction: column;
  margin: 0 0.1rem;
}
.head-bank {
  height: 0.1rem;
  width: 100%;
}
/* 1px的线 */
.fix-1px {
  position: relative;
  border: none;
}

.fix-1px:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  background: #efefef;
  width: 100%;
  height: 1px;
  -webkit-transform: scaleY(0.5) translateY(1px);
  transform: scaleY(0.5) translateY(1px);
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
}

.dialog-head {
  margin-top: 0.2rem;
  height: 0.5rem;
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
}
div {
  display: flex;
}
.ot-color {
  color: #666666;
  font-size: 0.12rem;
}
.dialog_mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.5);
}
.dialog_container {
  background-color: #fff;
  flex-direction: column;
  width: 100%;
  position: fixed;
  bottom: 0;
  z-index: 1;
}
</style>
